// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const UserCircle_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M16.125 11.25A4.125 4.125 0 1 1 12 7.125a4.13 4.13 0 0 1 4.125 4.125Zm5.625.75A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12Zm-1.5 0a8.26 8.26 0 0 0-8.575-8.243c-4.416.17-7.937 3.848-7.925 8.266a8.22 8.22 0 0 0 2.085 5.453 7.5 7.5 0 0 1 2.04-1.998.375.375 0 0 1 .453.03 5.61 5.61 0 0 0 7.339 0 .375.375 0 0 1 .452-.03 7.5 7.5 0 0 1 2.043 1.998A8.2 8.2 0 0 0 20.25 12Z',
  viewBox: '0 0 24 24',
  glyph: 'UserCircle_Filled_Corner0_Rounded',
})

export const UserCircle_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM6.945 18.516a6 6 0 0 1 10.11 0 8.234 8.234 0 0 1-10.11 0ZM9 11.25a3 3 0 1 1 3 3 3 3 0 0 1-3-3Zm9.165 6.226a7.47 7.47 0 0 0-3.38-2.695 4.5 4.5 0 1 0-5.57 0 7.47 7.47 0 0 0-3.38 2.695 8.25 8.25 0 1 1 12.33 0Z',
  viewBox: '0 0 24 24',
  glyph: 'UserCircle_Stroke2_Corner0_Rounded',
})
